// CarAnimation.js
import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./CarAnimation.css"; // external CSS file
/*
import carImg from "./assets/animation-car.png"; // adjust path to your image
*/
import carImg from "./assets/15-53-17-555_256.gif";

gsap.registerPlugin(ScrollTrigger);

const CarAnimation = () => {
    useEffect(() => {
        // Car zoom-in animation
        gsap.to("#car", {
            scrollTrigger: {
                trigger: "#animation-section",
                start: "top center",
                end: "bottom center",
                scrub: true,
            },
            width: "600px",
            opacity: 1,
            ease: "power2.in",
        });

        // Car headlights on
        gsap.to("#car", {
            scrollTrigger: {
                trigger: "#animation-section",
                start: "center center",
                toggleActions: "play reverse play reverse",
            },
            filter: "brightness(1)",
            ease: "power2.in",
        });

        // Text box animations
        gsap.fromTo(
            "#text1",
            { opacity: 0, x: -200, y: -200 },
            {
                scrollTrigger: {
                    trigger: "#animation-section",
                    start: "center center",
                    toggleActions: "play reverse play reverse",
                },
                opacity: 1,
                x: 0,
                y: 0,
                duration: 1,
            }
        );

        gsap.fromTo(
            "#text2",
            { opacity: 0, x: 200, y: -200 },
            {
                scrollTrigger: {
                    trigger: "#animation-section",
                    start: "center center",
                    toggleActions: "play reverse play reverse",
                },
                opacity: 1,
                x: 0,
                y: 0,
                duration: 1,
            }
        );

        gsap.fromTo(
            "#text3",
            { opacity: 0, x: -200, y: 200 },
            {
                scrollTrigger: {
                    trigger: "#animation-section",
                    start: "center center",
                    toggleActions: "play reverse play reverse",
                },
                opacity: 1,
                x: 0,
                y: 0,
                duration: 1,
            }
        );

        gsap.fromTo(
            "#text4",
            { opacity: 0, x: 200, y: 200 },
            {
                scrollTrigger: {
                    trigger: "#animation-section",
                    start: "center center",
                    toggleActions: "play reverse play reverse",
                },
                opacity: 1,
                x: 0,
                y: 0,
                duration: 1,
            }
        );
    }, []);

    return (
        <div>

            <div className="top-box"></div>
            <div className="animation-box" id="animation-section">
                <img src={carImg} alt="Car" className="car" id="car" />

                <div className="headlights" id="headlights"></div>

                <div className="text-boxs" id="text1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-cart2" viewBox="0 0 16 16">
                        <path d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5M3.14 5l1.25 5h8.22l1.25-5zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0" />
                    </svg>
                    <h3 className="mt-3">Reasons to Buy</h3>
                    <p>We offer high-quality used cars, machines, bikes, and trucks, ensuring the best value for your money with a focus on quality and reliability.</p>
                </div>
                <div className="text-boxs" id="text2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-car-front-fill" viewBox="0 0 16 16">
                        <path d="M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679q.05.242.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.8.8 0 0 0 .381-.404l.792-1.848ZM3 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m10 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2M6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2zM2.906 5.189a.51.51 0 0 0 .497.731c.91-.073 3.35-.17 4.597-.17s3.688.097 4.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 11.691 3H4.309a.5.5 0 0 0-.447.276L2.906 5.19Z" />
                    </svg>
                    <h3 className="mt-3">Get your car, where-ever you are</h3>
                    <p>With around multiple offices we can ship cars to Africa, Asia Caribbean, Oceania, Middle East, under continuous monitoring by our experienced staff.</p>
                </div>
                <div className="text-boxs" id="text3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                    </svg>
                    <h3 className="mt-3">Reliability is our identity</h3>
                    <p>Since a quarter of Century, M.I Japan is renowned for quick delivery and reliability of service.</p>
                </div>
                <div className="text-boxs" id="text4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-question-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                        <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94" />
                    </svg>
                    <h3 className="mt-3">Customer support 24/7</h3>
                    <p>Our dynamic team is on call around the clock to answer any query about shipped car via SKC JAPAN LiveChat, WhatsApp, Social Media, phones and emails.</p>
                </div>
            </div>


        </div>
    );
};

export default CarAnimation;
